{{ getLabel() | async }}
<mat-icon class="app-object-label-remove" (click)="onRemove($event)">cancel</mat-icon>
